/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/data';
import '../../customers/request';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      buyerportal: {
        nested: {
          preference: {
            nested: {
              MarketingOptInSetting: {
                values: {
                  MARKETING_OPT_IN_UNKNOWN: 0,
                  MARKETING_OPT_IN: 1,
                  MARKETING_OPT_OUT: 2,
                },
              },
              MerchantMarketingPreference: {
                fields: {
                  merchant: {
                    type: '.squareup.buyerportal.common.MerchantInfo',
                    id: 1,
                    rule: 'optional',
                  },
                  setting: {
                    type: '.squareup.buyerportal.preference.MarketingOptInSetting',
                    id: 2,
                    rule: 'optional',
                  },
                },
              },
              RetrieveMarketingPreferencesRequest: {
                fields: {
                  emailId: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  offset: {
                    type: 'int32',
                    id: 2,
                    rule: 'optional',
                  },
                  limit: {
                    type: 'int32',
                    id: 3,
                    rule: 'optional',
                  },
                },
              },
              RetrieveMarketingPreferencesResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                  globalSetting: {
                    type: '.squareup.buyerportal.preference.MarketingOptInSetting',
                    id: 3,
                    rule: 'optional',
                  },
                  merchantPreferences: {
                    type: '.squareup.buyerportal.preference.MerchantMarketingPreference',
                    id: 4,
                    rule: 'repeated',
                  },
                  totalMerchants: {
                    type: 'int32',
                    id: 5,
                    rule: 'optional',
                  },
                },
              },
              UpdateMarketingPreferenceRequest: {
                fields: {
                  emailId: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  merchantId: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  setting: {
                    type: '.squareup.buyerportal.preference.MarketingOptInSetting',
                    id: 3,
                    rule: 'optional',
                  },
                  copyId: {
                    type: 'string',
                    id: 4,
                    rule: 'optional',
                  },
                },
              },
              UpdateMarketingPreferenceResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                },
              },
              MarketingPreferencesService: {
                methods: {
                  RetrieveMarketingPreferences: {
                    requestType:
                      '.squareup.buyerportal.preference.RetrieveMarketingPreferencesRequest',
                    responseType:
                      '.squareup.buyerportal.preference.RetrieveMarketingPreferencesResponse',
                  },
                  UpdateMarketingPreference: {
                    requestType:
                      '.squareup.buyerportal.preference.UpdateMarketingPreferenceRequest',
                    responseType:
                      '.squareup.buyerportal.preference.UpdateMarketingPreferenceResponse',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.preference?.nested
    ?.MarketingPreferencesService
) {
  $root.addJSON(jsonData);
}

export const MarketingOptInSetting = $root.lookupEnum(
  'squareup.buyerportal.preference.MarketingOptInSetting'
).values;

export const MerchantMarketingPreference = $root.lookupType(
  'squareup.buyerportal.preference.MerchantMarketingPreference'
);
fixType(MerchantMarketingPreference);
Builder.createAndAttachToType(MerchantMarketingPreference);

export const RetrieveMarketingPreferencesRequest = $root.lookupType(
  'squareup.buyerportal.preference.RetrieveMarketingPreferencesRequest'
);
fixType(RetrieveMarketingPreferencesRequest, {
  emailId: { required: true },
});
Builder.createAndAttachToType(RetrieveMarketingPreferencesRequest);

export const RetrieveMarketingPreferencesResponse = $root.lookupType(
  'squareup.buyerportal.preference.RetrieveMarketingPreferencesResponse'
);
fixType(RetrieveMarketingPreferencesResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(RetrieveMarketingPreferencesResponse);

export const UpdateMarketingPreferenceRequest = $root.lookupType(
  'squareup.buyerportal.preference.UpdateMarketingPreferenceRequest'
);
fixType(UpdateMarketingPreferenceRequest, {
  emailId: { required: true },
  setting: { required: true },
});
Builder.createAndAttachToType(UpdateMarketingPreferenceRequest);

export const UpdateMarketingPreferenceResponse = $root.lookupType(
  'squareup.buyerportal.preference.UpdateMarketingPreferenceResponse'
);
fixType(UpdateMarketingPreferenceResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(UpdateMarketingPreferenceResponse);

export const MarketingPreferencesService = $root.lookupService(
  'squareup.buyerportal.preference.MarketingPreferencesService'
);
